<template lang="html">
  <div class="centerx">
    <input id='fileinputcpt' type='file' accept='.csv' @change="readCSV($event, competitorChipsFull)" style="display: none;" />
    <!--<vs-button @click="popupActivo4=true" color="danger" type="border">Open fullscreen popup</vs-button>-->
    <vs-popup
      :title="'Éditer les concurrents de ' + society.name"
      :active.sync="popupActive"
    >
      <div class="container" style="min-width: 800px;max-width: 1000px;">
        <div class="vx-row mt-4 w-full">
          <div class="vx-col"><vs-input class="inputx" placeholder="Nouveau concurrent..." v-model="newCompetitor"/></div>
          <div class="vx-col"><vs-button @click="addCompetitor">Ajouter Concurrent</vs-button></div>
          <div class="vx-col"><vs-button @click="csvImport">Importer CSV</vs-button></div>
          <div class="vx-col">
            <vx-tooltip text='Importe la colonne "competitor" du fichier CSV. Enregistrez le CSV sous le format "CSV Windows" avec "Enregistrer sous...".'>
              <vs-avatar text="?" style="cursor: default;"></vs-avatar>
            </vx-tooltip>

          </div>
          <div class="vx-col"><strong><vs-chip :color="chipState">{{ competitorChipsFull.length }}/{{ competitorLimit }}</vs-chip></strong></div>

        </div>
        <vs-divider />
        <div class="vx-row mt-2 w-full">
          <div class="vx-col pt-2"><span>Chercher un concurrent : </span></div>
          <div class="vx-col"><vs-input class="inputx" placeholder="Concurrent recherché..." v-model="competitorQuery" /></div>
          <div class="vx-col pt-2"><strong class="float-right">Nombre de concurrents affichés : {{ competitorChips.length }}</strong></div>
        </div>
        <vs-divider />
        <div class="vx-row mt-4">
          <vs-chip @click="remove(competitor)" :key="index" v-for="(competitor,index) of competitorChips" closable>{{ competitor }}</vs-chip>
          <!-- <vs-textarea v-model="stringBrands" height="200px" rows="10" /> -->
        </div>
        <div class="vx-row float-right">
          <vs-button color="danger" type="filled" @click="closePopup"
            >Annuler</vs-button
          >
          <vs-button color="success" type="filled" @click="save" class="ml-2"
            >Sauvegarder</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
	name: "CompetitorEditorPopup",
	props: {
		society: Object,
		popupActive: {
			type: Boolean,
			default: false
		},
		competitors: Array
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			stringCompetitors: null,
			competitorCounter: 0,
			competitorLimit: 9,
			errorLimit: false,
			competitorChipsFull: [],
			competitorChips: [],
			competitorQuery: "",
			newCompetitor: "",
			chipState: "success"
		};
	},
	created() {
		this.competitorCounter = this.$props.competitors.length;
		this.stringCompetitors = this.$props.competitors.join(", ");
		this.competitorChipsFull = this.$props.competitors.map(competitor => competitor.toLowerCase());
		this.competitorChips = this.$props.competitors.map(competitor => competitor.toLowerCase());
	},
	watch: {
		competitors: function(data){
			this.competitorCounter = data.length;
			this.stringCompetitors = data.join(", ");
			this.competitorChipsFull = data.map(competitor => competitor.toLowerCase());
			this.competitorChips = data.map(competitor => competitor.toLowerCase());
		},
		competitorQuery: function(data){
			this.competitorChips = this.competitorChipsFull.filter(chip => chip.includes(data.toLowerCase()));
		},
		competitorChipsFull: function(data){
			this.competitorChips = data.filter(chip => chip.includes(this.competitorQuery.toLowerCase()));
			this.checkCompetitorLimit();
		},
		/**
		 * When the props coming from parent changes, we update it
		 */
		/*
		 * society: {
		 *   immediate: true,
		 *   handler: function(newVal, oldVal) {
		 *     this.topkeywords = JSON.parse(newVal.topkeywords).join(",");
		 *   },
		 *   deep: true
		 * }
		 */
	},
	methods: {
		addCompetitor(){
			let url = new URL(this.newCompetitor.toLowerCase());
			let hostname = url.hostname;
			this.competitorChipsFull.push(hostname);
			this.newCompetitor = "";
		},
		addCompetitors(competitors){
			for(let competitor of competitors){
				if(this.competitorChipsFull.includes(competitor.toLowerCase()) == false){
					this.competitorChipsFull.push(competitor.toLowerCase());
				}
			}
		},
		checkCompetitorLimit() {
			// this.competitorCounter = text.split(',').length
			if(this.competitorChipsFull.length > this.competitorLimit){
				// //console.log(text.split(','))
				this.chipState = "danger";
				this.errorLimit = true;
			}
			else{
				this.chipState = "success";
				this.errorLimit = false;
			}
		},
		csvImport(){
			//console.log("csvImport");
			let inputFile = document.getElementById("fileinputcpt");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, competitors){
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addCompetitors;
			reader.onload = function(e) {
				let mergedKeywords = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, {type: "array"});
				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_competitors = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]], {raw: true, defval: null});
				// //console.log("fetched_competitors", fetched_competitors)
				if(fetched_competitors.length > 0){
					mergedKeywords = [...competitors];
					// //console.log("mergedKeywords", mergedKeywords)
					fetched_competitors.forEach(row => {
						if(row.competitor && row.competitor !== null){
							if(!mergedKeywords.includes(row.competitor)) mergedKeywords.push(row.competitor);
							// //console.log("mergedKeywords updated", mergedKeywords)
						}
					});
					//console.log(mergedKeywords);
					// let stringMergedKeywords = mergedKeywords.join(',')
					callback(mergedKeywords);
				}
			};
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedKeywords updated 2", this.mergedKeywords) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedKeywords)
			 */
		},
		save() {
			if(this.errorLimit == false){
				this.$emit("close-popup", false);
				this.$emit("updated-competitors", this.competitorChipsFull.join(","));
			}
		},
		remove(item){
			this.competitorChipsFull.splice(this.competitorChipsFull.indexOf(item), 1);
			this.competitorChips.splice(this.competitorChips.indexOf(item), 1);
		},
		closePopup() {
			this.competitorChipsFull = this.$props.competitors;
			this.$emit("close-popup", false);
		}
	}
};
</script>
